<template>
  <div style="height:100%; width: 100%; display: flex; flex-direction: column; justify-content: flex-start;">
      <div v-for="group in formGroups" :key="key(group.identifiers)" style="padding-bottom: 1.5rem; display: flex; flex-direction: column; justify-content: flex-start; width: 100%; padding: 1rem;">
        <form-group
          :editable="group.editable"
          :title="group.title"
          :formFields="group.fields"
          :initialValues="group.initialValues"
          :identifiers="group.identifiers"
          @change="(change) => $emit('change', change)"
          :pasteCallback="copiedConfig"
          @copy="(value) => setCopiedConfig(value)"
          @deactivate="(change) => $emit('deactivate', change)"
          :canDelete="group.identifiers.key !== ('cameras')"
          />
      </div>
  </div>
</template>

<script>
import FormGroup from '@/libraries/owal-ui/forms-v2/FormGroup'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'ConfigForm',
  components: {
    FormGroup,
  },
  props: ['formGroups', 'callback'],
  methods: {
    key (identifiers) {
      const id = Object.entries(identifiers).filter(pair => pair[0] !== 'key')[0][1]
      return `${id}-${identifiers.key}`
    },
    ...mapGetters({
      copiedConfig: 'dnaConfiguration/copiedConfig',
    }),
    ...mapMutations({
      setCopiedConfig: 'dnaConfiguration/setCopiedConfig',
    }),
  },
}
</script>

<style>
  .notifications_view--settings_block {
    margin-bottom: 1rem;
  }
</style>
